export default function QuestionHeading({ children }: { children: string }) {
    return <h2 className="text-2xl md:text-3xl font-title text-center">{children}</h2>
}